const SKU = ({ skuId = '', skuTitle = '', skuType = 'alLaCarte' } = {}) => ({
  SKU: { skuId, skuTitle, skuType },
});

export default SKU;
